import { FC } from "react";

import { useScrollToHashOnFirstRender } from "shared/utils";

import { EditEventType, EditEventTicketAndPass, EditEventInfoBlocks } from "./containers";

export const EditEventSettingsPage: FC = () => {
  useScrollToHashOnFirstRender();

  return (
    <>
      <EditEventType />
      <EditEventTicketAndPass />
      <EditEventInfoBlocks />
    </>
  );
};
